import {
    SAVE_MENSTRUAL_CYCLE_INITIAL_SETUP_FAIL,
    SAVE_MENSTRUAL_CYCLE_INITIAL_SETUP_SUCCESS,
    SAVE_MENSTRUAL_CYCLE_INITIAL_SETUP_START,
    SET_MENSTRUAL_CYCLE_INITIAL_SETUP,
    UNSET_MENSTRUAL_CYCLE_INITIAL_SETUP,
    SET_MENSTRUAL_CYCLE_INITIAL_SETUP_STEP1,
    UNSET_MENSTRUAL_CYCLE_INITIAL_SETUP_STEP1,
    OPEN_MCT_INITIAL_SETUP_ALL_SET_MODAL,
    CLOSE_MCT_INITIAL_SETUP_ALL_SET_MODAL
} from '../../actions/ActionTypes';
import { RESET_MENSTRUAL_CYCLE_INITIAL_SETUP_SAVE_STATUS } from 'actions/ActionTypes';

const INITIAL_STATE = {
    menstrualCycleTrackingInitialSetupSaveRequesting: false,
    menstrualCycleTrackingInitialSetupSaveSuccess: null,
    showInitialSetupFromInactiveUser: false,
    showInitialSetupStep1FromInactiveUser: false,
    showMctInitialSetupAllSetModal: false
};

const setMenstrualCycleTrackingInitialSetupSaveRequesting = (state) => {
    return {
        ...state,
        menstrualCycleTrackingInitialSetupSaveRequesting: true
    };
};

const setMenstrualCycleTrackingInitialSetupSaveState = (isSuccess) => (state) => {
    return {
        ...state,
        menstrualCycleTrackingInitialSetupSaveSuccess: isSuccess,
        menstrualCycleTrackingInitialSetupSaveRequesting: false
    };
};

const resetMenstrualCycleTrackingInitialSetupSaveStatus = (state) => {
    return {
        ...state,
        menstrualCycleTrackingInitialSetupSaveSuccess: INITIAL_STATE.menstrualCycleTrackingInitialSetupSaveSuccess
    };
};

const setMenstrualCycleInitialSetup = (show) => (state) => {
    return {
        ...state,
        showInitialSetupFromInactiveUser: show
    };
};

const setMenstrualCycleInitialSetupStep1 = (show) => (state) => {
    return {
        ...state,
        showInitialSetupStep1FromInactiveUser: show
    };
};

const setMctInitialSetupAllSetModal = (show) => (state) => {
    return {
        ...state,
        showMctInitialSetupAllSetModal: show
    };
};

export const getMenstrualCycleInitialSetupSaveState = (state) => {
    return state.menstrualCycleTrackingInitialSetup.menstrualCycleTrackingInitialSetupSaveSuccess;
};

export const getMenstrualCycleInitialSetup = (state) => {
    return state.menstrualCycleTrackingInitialSetup.showInitialSetupFromInactiveUser;
};

export const getMenstrualCycleInitialSetupStep1 = (state) => {
    return state.menstrualCycleTrackingInitialSetup.showInitialSetupStep1FromInactiveUser;
};

export const getMctInitialSetupAllSetModal = (state) => {
    return state.menstrualCycleTrackingInitialSetup.showMctInitialSetupAllSetModal;
};

const handlers = {
    [SAVE_MENSTRUAL_CYCLE_INITIAL_SETUP_START]: setMenstrualCycleTrackingInitialSetupSaveRequesting,
    [SAVE_MENSTRUAL_CYCLE_INITIAL_SETUP_SUCCESS]: setMenstrualCycleTrackingInitialSetupSaveState(true),
    [SAVE_MENSTRUAL_CYCLE_INITIAL_SETUP_FAIL]: setMenstrualCycleTrackingInitialSetupSaveState(false),
    [RESET_MENSTRUAL_CYCLE_INITIAL_SETUP_SAVE_STATUS]: resetMenstrualCycleTrackingInitialSetupSaveStatus,
    [SET_MENSTRUAL_CYCLE_INITIAL_SETUP]: setMenstrualCycleInitialSetup(true),
    [UNSET_MENSTRUAL_CYCLE_INITIAL_SETUP]: setMenstrualCycleInitialSetup(false),
    [SET_MENSTRUAL_CYCLE_INITIAL_SETUP_STEP1]: setMenstrualCycleInitialSetupStep1(true),
    [UNSET_MENSTRUAL_CYCLE_INITIAL_SETUP_STEP1]: setMenstrualCycleInitialSetupStep1(false),
    [OPEN_MCT_INITIAL_SETUP_ALL_SET_MODAL]: setMctInitialSetupAllSetModal(true),
    [CLOSE_MCT_INITIAL_SETUP_ALL_SET_MODAL]: setMctInitialSetupAllSetModal(false)
};

export default function menstrualCycleTrackingInitialSetup(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
